export const vehicles = {
  title: 'Gestion des Véhicules',
  subtitle: 'Gérez votre flotte de véhicules',
  
  // Actions
  addVehicle: 'Ajouter un Véhicule',
  addFirstVehicle: 'Ajouter Votre Premier Véhicule',
  editVehicle: 'Modifier le Véhicule',
  deleteVehicle: 'Supprimer le Véhicule',
  viewDetails: 'Voir les Détails',
  addLocation: 'Ajouter un emplacement',
  locationManagement: 'Gestion des emplacements',
  
  // Status
  available: 'Disponible',
  rented: 'Loué',
  maintenance: 'Maintenance',
  
  // Form fields
  make: 'Marque',
  model: 'Modèle',
  year: 'Année',
  color: 'Couleur',
  category: 'Catégorie',
  transmission: 'Transmission',
  fuelType: 'Type de Carburant',
  seats: 'Places',
  pricePerDay: 'Prix par Jour',
  features: 'Équipements',
  description: 'Description',
  images: 'Images',
  location: 'Emplacement du véhicule',
  selectLocation: 'Sélectionnez un emplacement',
  selectLocations: 'Sélectionnez les emplacements',
  locationRequired: 'Veuillez sélectionner au moins un emplacement',
  
  // Table headers
  image: 'Image',
  availability: 'Disponible',
  pricePerDayShort: 'Prix/Jour',
  statusHeader: 'Statut',
  
  // Column settings
  columnSettings: 'Paramètres des colonnes',
  basicInformation: 'Informations de base',
  vehicleDetails: 'Détails du véhicule',
  maintenanceLegal: 'Maintenance & Légal',
  systemInformation: 'Informations système',
  
  // Bulk actions
  bulkActions: 'Actions',
  markAsAvailable: 'Marquer disponible',
  markAsRented: 'Marquer loué',
  markAsMaintenanceShort: 'Marquer en maintenance',
  exportCsv: 'Exporter CSV',
  
  // Messages
  vehicleSelectedCount: '{{count}} véhicule(s) sélectionné(s)',
  vehicleDeletedSuccessfully: 'Véhicule supprimé avec succès',
  vehicleDeletedDesc: 'Le véhicule a été retiré de votre flotte.',
  failedToDeleteVehicle: 'Échec de la suppression du véhicule',
  vehiclesDeletedSuccessfully: '{{count}} véhicules supprimés',
  vehiclesDeletedDesc: 'Les véhicules sélectionnés ont été supprimés avec succès.',
  vehiclesStatusUpdated: '{{count}} véhicules marqués comme {{status}}',
  vehiclesStatusUpdatedDesc: 'Le statut des véhicules sélectionnés a été mis à jour.',
  vehiclesExported: '{{count}} véhicules exportés',
  vehiclesExportedDesc: 'Les données des véhicules ont été exportées en CSV.',
  errorOccurred: 'Une erreur est survenue. Veuillez réessayer.',
  statusUpdatedSuccessfully: 'Statut du véhicule mis à jour',
  statusUpdatedDesc: 'Le statut du véhicule a été mis à jour avec succès.',
  failedToUpdateStatus: 'Échec de la mise à jour du statut du véhicule',
  failedToUpdateStatusDesc: 'Une erreur s\'est produite lors de la mise à jour du statut du véhicule.',
  
  // Empty states
  noVehiclesFound: 'Aucun véhicule trouvé',
  noVehiclesFoundDesc: 'Essayez de modifier vos critères de recherche ou filtres pour voir plus de résultats.',
  
  // Registration number
  registrationNumber: 'Numéro d\'immatriculation',
  registrationRequired: 'Le numéro d\'immatriculation est obligatoire',
  registrationInvalid: 'Le numéro d\'immatriculation doit contenir plus de 3 caractères',
  
  // Image upload
  vehicleImages: 'Images du véhicule (Max 6)',
  clickToAddImages: 'Cliquez pour ajouter des images',
  dragDropImages: 'Ou glissez-déposez vos images ici',
  imageFormats: 'PNG, JPG jusqu\'à 6 images',
  addImageButton: 'Ajouter',
  
  // Features
  featuresAndOptions: 'Équipements et options',
  addAll: 'Ajouter tout',
  noFeaturesSelected: 'Aucun équipement sélectionné',
  clickToAddQuickly: 'Cliquez pour ajouter rapidement :',
  enterFeature: 'Entrez le nom de la caractéristique',
  
  // Features list
  featuresList: {
    airConditioning: 'Climatisation',
    powerSteering: 'Direction assistée',
    centralLocking: 'Verrouillage centralisé',
    electricWindows: 'Lève-vitres électriques',
    radio: 'Radio',
    gpsNavigation: 'GPS/Navigation',
    bluetooth: 'Bluetooth',
    backupCamera: 'Caméra de recul',
    parkingSensors: 'Capteurs de stationnement',
    heatedSeats: 'Sièges chauffants',
    sunroof: 'Toit ouvrant',
    alloyWheels: 'Jantes alliage',
    ledHeadlights: 'Phares LED',
    cruiseControl: 'Régulateur de vitesse',
    premiumAudio: 'Système audio premium',
    usbAux: 'USB/AUX',
    keylessStart: 'Démarrage sans clé',
    sideAirbags: 'Airbags latéraux',
    abs: 'ABS',
    esp: 'ESP',
    brakeAssist: 'Assistance au freinage',
    blindSpotDetection: 'Détection d\'angle mort',
    laneAssist: 'Avertisseur de sortie de voie',
    heatedWindshield: 'Pare-brise chauffant',
    electricMirrors: 'Rétroviseurs électriques'
  },
  
  // Maintenance
  maintenanceInformation: 'Informations de maintenance',
  registrationNumberRequired: 'Numéro d\'immatriculation *',
  currentMileage: 'Kilométrage actuel',
  insuranceExpiry: 'Expiration de l\'assurance',
  insuranceExpiryShort: 'Expiration assurance',
  technicalControlExpiry: 'Expiration contrôle technique',
  technicalControlExpiryShort: 'Expiration contrôle technique',
  circulationPermitExpiry: 'Expiration autorisation circulation',
  circulationPermitExpiryShort: 'Expiration autorisation circulation',
  oilChangeDueDate: 'Prochaine vidange',
  lastOilChange: 'Dernière vidange',
  lastOilChangeShort: 'Dernière vidange',
  lastOilChangeMileage: 'Kilométrage dernière vidange',
  lastOilChangeMileageShort: 'Km dernière vidange',
  oilChangeInterval: 'Intervalle vidange (km)',
  oilChangeIntervalShort: 'Intervalle vidange (km)',
  maintenanceNotes: 'Notes de maintenance',
  maintenanceNotesShort: 'Notes de maintenance',
  
  // System fields
  createdAt: 'Date de création',
  updatedAt: 'Dernière modification',
  actions: 'Actions',
  
  // Color search
  searchColor: 'Tapez pour rechercher une couleur...',
  
  // Brand and model search
  searchBrand: 'Tapez pour rechercher une marque...',
  selectModel: 'Sélectionnez un modèle...',
  selectBrandFirst: 'Sélectionnez d\'abord une marque',
  
  // Error messages
  correctErrors: 'Veuillez corriger les erreurs suivantes :',
  yearInvalid: 'L\'année doit être comprise entre 1900 et 2030',
  seatsInvalid: 'Le nombre de places doit être compris entre 1 et 15',
  mileageInvalid: 'Le kilométrage ne peut pas être négatif',
  oilChangeMileageInvalid: 'Le kilométrage de la dernière vidange ne peut pas être négatif',
  oilChangeMileageGreaterThanCurrent: 'Le kilométrage de la dernière vidange ne peut pas être supérieur au kilométrage actuel',
  oilChangeIntervalInvalid: 'L\'intervalle de vidange doit être d\'au moins 1000 km',
  oilChangeDateInvalid: 'La date de la dernière vidange ne peut pas être dans le futur',
  failedToUploadImage: 'Échec du téléchargement de l\'image {{fileName}}: {{error}}',
  
  // Form actions
  clearAll: 'Effacer tout',
  clearForm: 'Effacer le formulaire',
  clearFormMessage: 'Êtes-vous sûr de vouloir effacer toutes les données du formulaire ? Cette action ne peut pas être annulée.',
  
  // Validation messages
  makeRequired: 'La marque est obligatoire',
  modelRequired: 'Le modèle est obligatoire',
  colorRequired: 'La couleur est obligatoire',
  categoryRequired: 'La catégorie est obligatoire',
  transmissionRequired: 'Le type de transmission est obligatoire',
  fuelTypeRequired: 'Le type de carburant est obligatoire',
  priceRequired: 'Le prix par jour est obligatoire',
  
  // Categories
  categories: {
    economy: 'Économique',
    compact: 'Compacte',
    midsize: 'Taille Moyenne',
    fullsize: 'Grande Taille',
    luxury: 'Luxe',
    suv: 'SUV',
    convertible: 'Cabriolet',
  },
  
  // Transmission types
  automatic: 'Automatique',
  manual: 'Manuelle',
  
  // Fuel types
  fuelTypes: {
    gasoline: 'Essence',
    diesel: 'Diesel',
    hybrid: 'Hybride',
    electric: 'Électrique',
    lpg: 'GPL',
  },
  
  // Status labels
  status: {
    available: 'Disponible',
    rented: 'Loué',
    maintenance: 'Maintenance',
  },
  
  // Messages
  noVehicles: 'Aucun Véhicule Trouvé',
  noVehiclesDesc: 'Ajoutez votre premier véhicule pour commencer à gérer votre flotte.',
  totalVehicles: '{{count}} véhicules trouvés',
  vehicleAdded: 'Véhicule ajouté avec succès',
  vehicleUpdated: 'Véhicule mis à jour avec succès',
  vehicleDeleted: 'Véhicule supprimé avec succès',
  failedToAdd: 'Échec de l\'ajout du véhicule',
  failedToUpdate: 'Échec de la mise à jour du véhicule',
  permissionDenied: 'Autorisation refusée. Assurez-vous d\'avoir accès à la gestion des véhicules pour cette agence.',
  duplicateError: 'Un véhicule avec ces informations existe déjà. Veuillez vérifier le numéro d\'immatriculation ou d\'autres champs uniques.',
  constraintError: 'Données non valides fournies. Veuillez vérifier tous les champs obligatoires.',
  networkError: 'Erreur réseau. Veuillez vérifier votre connexion internet et réessayer.',
  
  // Actions
  delete: 'Supprimer',
  deleteAll: 'Supprimer tout',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  deleteConfirmTitle: 'Supprimer le véhicule',
  deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce véhicule ? Cette action est irréversible.',
  deleteAllConfirmTitle: 'Supprimer les véhicules sélectionnés',
  deleteAllConfirmMessage: 'Êtes-vous sûr de vouloir supprimer les {{count}} véhicules sélectionnés ? Cette action est irréversible.',
  
  // Filters
  allCategories: 'Toutes les Catégories',
  allTransmissions: 'Toutes les Transmissions',
  allStatuses: 'Tous les Statuts',
  searchPlaceholder: 'Rechercher par marque, modèle ou année...',
  
  // Placeholders additionnels
  selectDate: 'Sélectionner une date',
  enterRegistrationNumber: 'Ex: ABC-123-45 (obligatoire)',
  enterMileage: 'Ex: 50000',
  enterLastServiceMileage: 'Ex: 45000',
  enterMaintenanceNotes: 'Notes sur l\'entretien, réparations, etc...',
}; 